import { AUTOCOMPLETE_CLEAR_RESULT, AUTOCOMPLETE_CLEAR_STATE, AUTOCOMPLETE_FETCH_FAILED, AUTOCOMPLETE_FETCH_OK, AUTOCOMPLETE_START_FETCHING } from "../Actions/ActionAutocomplete";

const inititalState = {
  error: null,
  isFetching: false,
  items: [],
  meta: null,
  request: null,
  foundByTerm: ''
};

export const autocomplete = (state = inititalState, action) => {
  switch (action.type) {
    case AUTOCOMPLETE_CLEAR_RESULT:
      return Object.assign({}, state, {
        items: [],
        isFetching: false,
        foundByTerm: ''
      });
    case AUTOCOMPLETE_CLEAR_STATE:
      return inititalState;
    case AUTOCOMPLETE_START_FETCHING:
      return Object.assign({}, state, {
        isFetching: true,
        foundByterm: ''
      });
    case AUTOCOMPLETE_FETCH_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        items: [],
        meta: null,
        error: action.error,
        foundByTerm: ''
      });
    case AUTOCOMPLETE_FETCH_OK:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.data.search_autocomplete_result,
        meta: action.data._meta_,
        error: null,
        foundByTerm: action.data.term
      });
    default:
      return state;

  }
};